<form [formGroup]="dynamicFormGroup" autocomplete="off">
  <div class="control-container">
    @for (control of dynamicForm; track control) {
      <div>
        @if (
          [
          formControlTypes.Textbox,
          formControlTypes.NumericTextbox,
          formControlTypes.DatePicker
          ].includes(control.displayType)
          ) {
          <atlas-input
            [control]="control"
            [attr.data-test-name]="control.name">
          </atlas-input>
        }
        @if (control.displayType === formControlTypes.ComboBox) {
          <atlas-select
            [control]="control">
          </atlas-select>
        }
        @if (control.displayType === formControlTypes.Checkbox) {
          <atlas-checkbox
            [control]="control">
          </atlas-checkbox>
        }
        @if (control.displayType === formControlTypes.Radio) {
          <atlas-radio-button
            [control]="control">
          </atlas-radio-button>
        }
        @if (control.displayType === formControlTypes.Slider) {
          <atlas-slider-toggle
            [control]="control">
          </atlas-slider-toggle>
        }
        @if (control.displayType === formControlTypes.List) {
          <atlas-list-selection
            [control]="control">
          </atlas-list-selection>
        }
      </div>
    }
  </div>
</form>
